/**
 * Các thông điệp thiết lập nền tảng
 */
export default {
  /**
   * Trạng thái chờ thiết lập
   */
  waitingSetup: 'Đang chờ thiết lập bắt đầu sử dụng',

  /**
   * Quản trị hệ thống đang thiết lập nền tảng
   */
  systemAdminSetup: (appNames) => `Quản trị hệ thống đang thiết lập bắt đầu sử dụng nền tảng MISA ${appNames}`,

  /**
   * Nền tảng đang thiết lập danh mục dùng chung
   */
  coreSetupInProgress:  (appNames) => `MISA ${appNames} đang trong quá trình thiết lập các danh mục dùng chung toàn hệ thống`,

  /**
   * Mô tả chờ thiết lập hoàn tất
   */
  waitSetupComplete: 'Vui lòng chờ quá trình thiết lập hoàn tất để sử dụng ứng dụng.',

  /**
   * Mô tả chờ dependency hoàn tất
   */
  waitDependencyComplete: 'Vui lòng quay lại sau khi quá trình trên hoàn tất.',

  /**
   * Thông điệp quản trị ứng dụng đang thiết lập
   * @param {string} appName - Tên ứng dụng
   * @returns {string} Thông điệp thiết lập app
   */
  appSystemSetup: (appName) => `Quản trị ứng dụng đang thiết lập bắt đầu sử dụng ứng dụng ${appName}`,

  /**
   * Thông điệp chờ dependency app
   * @param {string} dependentApps - Tên các app phụ thuộc
   * @param {string} currentApp - Tên app hiện tại
   * @returns {string} Thông điệp dependency
   */
  salagovDependency: (dependentApps, currentApp) => `Bạn cần chờ hoàn tất thiết lập ban đầu cho ứng dụng <strong>${dependentApps}</strong> trước khi sử dụng ứng dụng <strong>${currentApp}</strong>`,

  /**
   * Trạng thái chờ app Salagov
   * @param {string} appNames - Tên các ứng dụng
   * @returns {string} Trạng thái chờ
   */
  salagovStatus: (appNames) => `Đang chờ ứng dụng ${appNames} thiết lập bắt đầu sử dụng`,
  
  ResourceLevelMessage:(appNames) =>`Cấp tài nguyên bổ sung cho MISA ${appNames} thành công`
}; 